import { call, put } from 'redux-saga/effects';
import axios from './axiosHandler';
import { API_HOST } from '../env';
import sagaLoading from './sagaLoading';
import sagaGetAllSeries from './sagaGetAllSeries';
import sagaGetAllPrograms from './sagaGetAllPrograms';
import { MESSAGE_ERROR, MESSAGE_SUCCESS } from '../actions/actionTypes';

export default function* sagaDeleteSeries({ data }) {
  const serType = { type: data.type };
  try {
    yield call(sagaLoading, true);
    const resData = yield call(() =>
      axios({
        url: `${API_HOST}content/deleteSeries`,
        method: 'post',
        data: { id: data.id },
      }).then((response) => response.data)
    );
    yield call(sagaGetAllSeries, { serType });
    yield call(sagaGetAllPrograms, { serType });
    yield put({ type: MESSAGE_SUCCESS, payload: resData.message });
    yield call(sagaLoading, false);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield call(sagaLoading, false);
    yield put({
      type: MESSAGE_ERROR,
      payload: error.message ? error.message : 'There is something wrong, please, try again.',
    });
  }
}
